import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";

import LoginForm from "../components/LoginForm";
import avatar from "../assets/logo/sls2.png";
// import avatar from "../../assets/img/avatars/avatar.jpg";
// import avatar2 from "../../assets/img/avatars/avatar-3.jpg";
import { useNavigate } from "react-router-dom";
// import { ports } from "../../utils/ports";
// import { firstOauthURL } from "../../utils/apis";
// import { companies } from "../../utils/logoColor";

import "../components/style.css";

const LoginPage = () => {
  const navigate = useNavigate();
  const eventWork = async (e: any) => {
    console.log("get message111");
    console.log(e);
  };

  return (
    <div className="loginpage2">
      <div className="d-flex w-100 justify-content-center">
        <Container className="d-flex flex-column">
          <Row className="h-100">
            <Col sm="10" md="8" lg="6" className="mx-auto d-table h-100">
              <div className="d-table-cell align-middle">
                <div className="text-center mt-4 w-80">
                  <h2 className="text-white">Welcome back</h2>
                  <p className="text-white">
                    Sign in to your account to continue
                  </p>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Card style={{ width: "400px" }}>
                    <Card.Body>
                      <div className="m-sm-4 formstyle">
                        <div className="text-center">
                          <img
                            src={avatar}
                            alt="SLS logo"
                            className="img-fluid rounded-circle"
                            width="132"
                            height="132"
                          />
                        </div>
                        <LoginForm />
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default LoginPage;
